module.exports = __webpack_public_path__ + "90b156f576c1f53c56d1fedee3ca1c3d.MP3";